import type { AdminProcess } from '@frontend/components/pages/processes/adminProcessDetailsTypes';
import { FormDivider, FormParagraph } from '@frontend/components/elements/common';
import { FormLabel } from '@frontend/components/elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '@frontend/components/elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '@frontend/components/elements/forms/InputContainer';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';

export function GgzoIntV1AdminDetails(props: AdminProcess) {
    if (!props.customControlData) {
        return null;
    }

    return (
        <>
            <FormDivider />
            <HorizontalFormGroupRead>
                <FormLabel>Formulier</FormLabel>
                <InputContainer>
                    <FormParagraph>DIPP</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>

            <HorizontalFormGroupRead>
                <FormLabel>Nameting</FormLabel>
                <InputContainer>
                    <FormParagraph>{getNameting()}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>
        </>
    );

    function getNameting() {
        if (!props.customControlData.heeftNameting) {
            return 'Nee';
        }

        return <>Ja, op {<NullableFormattedDate value={props.customControlData.nametingOp} />}</>;
    }
}
